import { Dialog } from "primereact/dialog";
import styled from "styled-components";

export const StyledDialog = styled(Dialog)`
	width: 40%;
	@media (max-width: 768px) {
		width: 80%;
	}
`;
